import { FaCheckCircle } from "react-icons/fa";

const ServiceFeatures = ({ service }) => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container-custom">

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            What We Offer
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Services Included
          </h2>

        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {service.features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-md border border-gray-100"
            >

              <FaCheckCircle className="text-[#F59E0B] text-3xl mb-5" />

              <h3 className="text-xl font-bold text-[#082B57]">
                {feature}
              </h3>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ServiceFeatures;